import { useSnackbar } from 'notistack'
import { useEffect } from 'react'
import {
    useGetTotalApiV1NotificationsFeedUserEventTotalGet,
    UserNotification,
} from '../api/gen/base'
import { useInvalidateNotificationsFeedUserEventListQuery } from '../api/hooks/useInvalidateNotificationsFeedUserEventListQuery'
import { useSocketData } from '../api/websockets/useSocketData'
import { useNotificationsStore } from '../store/storeNotifications'

export const useNotifications = () => {
    const invalidateNotificationsListQueries = useInvalidateNotificationsFeedUserEventListQuery()

    const { data: newNotification } = useSocketData<UserNotification>('notifications_feed/ws')

    const { enqueueSnackbar } = useSnackbar()

    const { setNumberOfUnreadNotifications } = useNotificationsStore((state) => state)

    const { data: totalData, refetch: refetchTotal } =
        useGetTotalApiV1NotificationsFeedUserEventTotalGet()

    useEffect(() => {
        if (totalData) {
            setNumberOfUnreadNotifications(totalData.total)
        }
    }, [totalData])

    useEffect(() => {
        if (newNotification) {
            refetchTotal()
            invalidateNotificationsListQueries()

            enqueueSnackbar(newNotification.message, {
                variant: 'push',
                anchorOrigin: { horizontal: 'right', vertical: 'top' },
                title: newNotification.event.title,
                eventCode: newNotification.event.code,
            })
        }
    }, [newNotification])
}
